<template>
  <div class="tw:flex tw:flex-wrap tw:items-center tw:gap-2">
    <LeadStatusPill :status="props.order?.is_draft ? 'draft' : props.order?.lead_order_status" />
    <LeadPill v-if="displayBudget" tone="neutral" :icon="IconCoins">{{ budgetLabel }}</LeadPill>
    <LeadPill tone="neutral" :icon="IconPercentage">{{ workloadText }}</LeadPill>
    <LeadPill tone="neutral" :icon="IconMapPin" class="tw:min-w-0 tw:max-w-[260px]">
      <span class="tw:truncate">{{ workplace_location || $t('orders.list.worldwide') }}</span>
    </LeadPill>
    <LeadPill v-if="creatorName" tone="neutral" :icon="IconUserCheck">
      {{ creatorName }}
    </LeadPill>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { IconCoins, IconPercentage, IconMapPin, IconUserCheck } from '@tabler/icons-vue';
import LeadPill from '@/components/lead-design/LeadPill.vue';
import LeadStatusPill from '@/components/lead-design/LeadStatusPill.vue';
import type { Order } from '@/types/types';
import { budgetText } from '@/components/orders/orderFormatters';
import { useCustomerFeaturesStore } from '@/stores/customerFeatures';

const props = defineProps<{ order: Order }>();
const { workplace_location, workload_min, workload_max } = props.order || {};
const featureStore = useCustomerFeaturesStore();

/* --------------------------------- COMPUTED ------------------------------- */

const displayBudget = computed(() => featureStore.featureOrderManagment?.display_budget);

const workloadText = computed(() => {
  if (workload_min === 100) return '100%';
  return `${workload_min || 0}% - ${workload_max || 100}%`;
});

// same helper the orders table uses so both views format identically.
const budgetLabel = computed(() => budgetText(props.order));

const creatorName = computed(() => props.order?.creator?.name || '');
</script>
